import { render } from "./bimgx-image.vue?vue&type=template&id=42379480&ts=true"
import script from "./bimgx-image.vue?vue&type=script&lang=ts"
export * from "./bimgx-image.vue?vue&type=script&lang=ts"

import exportComponent from "/srv/bimgx-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__